import React, { useState } from 'react'

const TextToImage = () => {
    const [jobId, setJobId] = useState(null)
    const [imageBase64, setImageBase64] = useState(null)
    const [finalImageBase64s, setFinalImageBase64s] = useState([])
    const [loading, setLoading] = useState(false)
    const [prompt, setPrompt] = useState('')
    const [performance, setPerformance] = useState('Speed')
    const [aspectRatio, setAspectRatio] = useState('1152*896')

    const handleGenerate = async () => {
        if (prompt === '') {
            alert('Please enter a prompt')
            return
        }
        setLoading(true)
        setImageBase64(null)

        const response = await fetch(
            'https://anuvadiniaiapi.aicte-india.org/speakpic/v1/generation/text-to-image',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    prompt: prompt,
                    async_process: 'True',
                    performance_selection: performance,
                    aspect_ratios_selection: aspectRatio,
                    negative_prompt: 'nsfw, nudity, explicit, sexual content',
                    require_base64: 'True',
                    image_number: 3,
                    advanced_params: {
                        black_out_nsfw: true,
                    },
                }),
            },
        )

        const data = await response.json()
        if (data.job_id) {
            setJobId(data.job_id)
            pollForResult(data.job_id)
        } else {
            alert('Failed to start generation')
            setLoading(false)
        }
    }

    const pollForResult = job_id => {
        const interval = setInterval(async () => {
            const statusResponse = await fetch(
                `https://anuvadiniaiapi.aicte-india.org/speakpic/v1/generation/query-job?job_id=${job_id}&require_step_preview=True`,
                {
                    method: 'GET',
                },
            )
            const statusData = await statusResponse.json()

            if (statusData.job_stage === 'WAITING') {
                setImageBase64(statusData.job_step_preview)
            }

            if (statusData.job_stage === 'SUCCESS') {
                setFinalImageBase64s(statusData.job_result)
                setLoading(false)
                clearInterval(interval)
            } else if (statusData.job_status === 'WAITING') {
                console.log(statusData.job_step_preview)
                setImageBase64(statusData.job_step_preview)
                setLoading(false)
                clearInterval(interval)
            }
        }, 1000)
    }

    return (
        <div style={{ padding: 20 }}>
            <div>
                <input
                    type="text"
                    value={prompt}
                    onChange={e => setPrompt(e.target.value)}
                />
            </div>
            <div>
                <ul>
                    <li>
                        <input
                            type="radio"
                            name="aspectRatio"
                            value="1152*896"
                            defaultChecked
                            onChange={e => setAspectRatio(e.target.value)}
                        />
                        <label>1152x896 (4:3)</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            name="aspectRatio"
                            value="896*1152"
                            onChange={e => setAspectRatio(e.target.value)}
                        />
                        <label>896x1152 (3:4)</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            name="aspectRatio"
                            value="1024*1024"
                            onChange={e => setAspectRatio(e.target.value)}
                        />
                        <label>1024x1024 (1:1)</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            name="aspectRatio"
                            value="1280*720"
                            onChange={e => setAspectRatio(e.target.value)}
                        />
                        <label>1280x720 (16:9)</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            name="aspectRatio"
                            value="720*1280"
                            onChange={e => setAspectRatio(e.target.value)}
                        />
                        <label>720x1280 (9:16)</label>
                    </li>
                </ul>
            </div>
            <div>
                <ul>
                    <li>
                        <input type="checkbox" />
                        <label>Black out NSFW</label>
                    </li>
                </ul>
            </div>
            <div>
                <ul>
                    <li>
                        <input
                            type="radio"
                            name="performance"
                            value="Speed"
                            defaultChecked
                            onChange={e => setPerformance(e.target.value)}
                        />
                        <label>Speed</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            name="performance"
                            value="Quality"
                            onChange={e => setPerformance(e.target.value)}
                        />
                        <label>Quality</label>
                    </li>
                    <li>
                        <input
                            type="radio"
                            name="performance"
                            value="Extreme Speed"
                            onChange={e => setPerformance(e.target.value)}
                        />
                        <label>Extreme speed</label>
                    </li>
                </ul>
            </div>
            <button onClick={handleGenerate} disabled={loading}>
                {loading ? 'Generating...' : 'Generate Image'}
            </button>

            {imageBase64 && (
                <div style={{ marginTop: 20 }}>
                    <h3>Generated Image:</h3>
                    <img
                        src={`data:image/png;base64,${imageBase64}`}
                        alt="Generated"
                        style={{ maxWidth: '100%', border: '1px solid #ccc' }}
                    />
                </div>
            )}
            {finalImageBase64s.map((base64, index) => (
                <div key={index} style={{ marginTop: 20 }}>
                    <h3>Final Image {index + 1}:</h3>
                    {console.log(base64)}
                    <img
                        src={`${base64.base64}`}
                        alt="Final"
                        style={{ maxWidth: '100%', border: '1px solid #ccc' }}
                    />
                </div>
            ))}
        </div>
    )
}

export default TextToImage
